/* global  __WATCH__:false */
export default class ShortcutsModel {
  constructor() {
    // DISPLAY
    this.currentPond = 'none';

    // DATA
    this.clearPlayerSaves = () => {};

    // GAME
    this.pondDebug = false;
    this.myCreaturesUnlocked = __WATCH__ ? true : false;
    this.arrowsUnlocked = false; // __WATCH__ ? true : false;

    // AUDIO
    this.sound = true;
    this.sfx = true;
    this.music = true;
    this.vo = true;

    this.captions = true;

    // LEVELS
    this.nextLevel = () => {};
  }
}
